import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { store } from '@/store/index';
import { readIsFeatureEnabled } from '@/store/main/getters';


export default /*#__PURE__*/_defineComponent({
  __name: 'V2Banner',
  setup(__props) {

const m = defineMessages({
  bannerMessage:
    '{year}年{month}月頃、ケミカンをより使いやすくするためにデザインをリニューアルいたします。お試し期間中は新デザインと旧デザインを切り替えることができます。',
  tryNewVersion: '新メニュー表示を試す',
});

const showBanner = computed(() =>
  readIsFeatureEnabled(store)('allow_v2_usage')
);
const [renewalYear, renewalMonth] = (
  process.env.VUE_APP_V2_RENEWAL_DATE || '2027/3'
).split('/');

const switchToV2 = () => {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `use_v2_frontend=true; path=/; expires=${expires.toUTCString()}`;
  window.location.href = '/';
};

return { __sfc: true,m, showBanner, renewalYear, renewalMonth, switchToV2 }
}

})